import { render, staticRenderFns } from "./TheFirmPage.vue?vue&type=template&id=05f626f2"
import script from "./TheFirmPage.vue?vue&type=script&lang=js"
export * from "./TheFirmPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports